import { ComposeViewState, composeStore } from 'owa-mail-compose-store';
import getRecipientWellValues from './getRecipientWellValues';
import type ReadWriteRecipientWellViewState from 'owa-recipient-types/lib/types/ReadWriteRecipientWellViewState';
import type { RecipientsCollection } from '../schema/RecipientsCollection';

export default function findComposeFromRecipientWell(
    recipientWell: ReadWriteRecipientWellViewState
): ComposeViewState {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (12,9): Type 'null' is not assignable to type 'ComposeViewState'.
    // @ts-expect-error
    let currentViewState: ComposeViewState = null;
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (16,9): Type 'null' is not assignable to type 'RecipientsCollection'.
    // @ts-expect-error
    let recipients: RecipientsCollection = null;
    if (recipientWell?.recipients) {
        for (const viewState of [...composeStore.viewStates.values()]) {
            recipients = getRecipientWellValues(viewState);
            if (
                recipients.toRecipients === recipientWell.recipients ||
                recipients.ccRecipients === recipientWell.recipients ||
                recipients.bccRecipients === recipientWell.recipients
            ) {
                currentViewState = viewState;
                break;
            }
        }
    }
    return currentViewState;
}
